import VantaBackground from "./VantaBackground";
import {IconLogoIEntryComplete} from "../../../components/buttons/IconButtons";
import React from "react";

/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azpata@ibl.mx
 * Created At: 19 de 05 de 2026
 */

const HomeAnimatedBackground = ({t}) => {

    return (
        <div className="d-none d-md-block flex-fill position-relative overflow-hidden background-shades-950 w-100 h-100">
            <VantaBackground />

            <div className="position-absolute-top-left">
                <IconLogoIEntryComplete className={'icon-color-general-00'} />
            </div>

            <div className="d-flex flex-column justify-content-center align-items-center h-100 px-5 py-5 position-relative pointer-event-none text-center font-color-general-00">
                <h1 className={"px-5"}>{t('marketing_title')}</h1>
                <p className={"px-5"}>{t('marketing_subtitle')}</p>
            </div>

            <div className="position-absolute-bottom-left font-color-general-00">
                {t('rights_reserved') + ' '}
                <b>{t('app_title')}</b>
            </div>
        </div>
    )
}

export default HomeAnimatedBackground
